import axios from "axios";

const API_URL = process.env.VUE_APP_SERVER_URL;

export const loginPlayer = async (email, password) => {
    return await axios.post(
        API_URL + '/api/player/login',
        {
            email: email,
            password: password,
        }
    );
};

export const registerPlayer = async (data) => {
    return await axios.post(API_URL + '/api/player/register', data);
}

export const checkAuth = async (token) => {
    return await axios.get(`${API_URL}/api/player/auth-check`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}